import {
	FileDocTypeLinker,
	FileClassificationLinker,
	FileLocationLinker,
	FileAssetsLinker,
	FileWorkOrdersLinker,
	FileIncidentLinker,
	FileRequestLinker,
	FileLabelLinker,
} from './files-linker';
import { ActionTypes, IActionCenterLinker } from '../../interfaces';
import { Injectable, inject } from '@angular/core';
import { FilesService } from '@app/pages/cmms/services/files.service';
import { TableType } from '@app/pages/cmms/types';
import {
	AssetClassificationLinker,
	AssetConditionGradeLinker,
	AssetFileLinker,
	AssetIncidentLinker,
	AssetLabelLinker,
	AssetLocationLinker,
	AssetRequestLinker,
	AssetWorkOrdersLinker,
} from './asset-linkers';
import { Apollo } from 'apollo-angular';
import {
	WorkOrderAssetLinker,
	WorkOrderCategoryLinker,
	WorkOrderDueDateLinker,
	WorkOrderFileLinker,
	WorkOrderIncidentLinker,
	WorkOrderLabelLinker,
	WorkOrderLocationLinker,
	WorkOrderPriorityLinker,
	WorkOrderRequestLinker,
	WorkOrderScheduleLinker,
	WorkOrderStatusLinker,
	workOrderApproverLinker,
	workOrderAssigneeLinker,
} from './work-orders-linker';
import {
	IncidentLabelLinker,
	IncidentStatusLinker,
	IncidentPriorityLinker,
	IncidentCategoryLinker,
	IncidentWorkOrderLinker,
	IncidentRequestLinker,
} from './incident-linker';
import {
	RequestLabelLinker,
	RequestStatusLinker,
	RequestPriorityLinker,
	RequestCategoryLinker,
	RequestWorkOrderLinker,
	RequestIncidentLinker,
} from './request-linker';

// TODO: Use TableType instead of string for tableType, atm it breaks the tests

@Injectable({
	providedIn: 'root',
})
export class ActionCenterLinkerFactory {
	linkerMap;
	filesService = inject(FilesService);
	private readonly apollo = inject(Apollo);

	deps = {
		[TableType.FILES]: {
			filesService: this.filesService,
			apollo: this.apollo,
		},
		[TableType.ASSETS]: { apollo: this.apollo },

		[TableType.WORK_ORDER]: { apollo: this.apollo },

		[TableType.INCIDENTS]: { apollo: this.apollo },

		[TableType.REQUESTS]: { apollo: this.apollo },
	};

	constructor() {
		this.linkerMap = {
			[TableType.FILES]: {
				locations: FileLocationLinker,
				documentType: FileDocTypeLinker,
				classifications: FileClassificationLinker,
				assets: FileAssetsLinker,
				work_order: FileWorkOrdersLinker,
				incident: FileIncidentLinker,
				request: FileRequestLinker,
				labels: FileLabelLinker,
			},
			[TableType.ASSETS]: {
				locations: AssetLocationLinker,
				classifications: AssetClassificationLinker,
				work_order: AssetWorkOrdersLinker,
				incident: AssetIncidentLinker,
				request: AssetRequestLinker,
				files: AssetFileLinker,
				labels: AssetLabelLinker,
				conditionGrade: AssetConditionGradeLinker,
			},
			[TableType.WORK_ORDER]: {
				locations: WorkOrderLocationLinker,
				category: WorkOrderCategoryLinker,
				priority: WorkOrderPriorityLinker,
				statusmessage: WorkOrderStatusLinker,
				due_date: WorkOrderDueDateLinker,
				schedule: WorkOrderScheduleLinker,
				assignee: workOrderAssigneeLinker,
				approver: workOrderApproverLinker,
				assets: WorkOrderAssetLinker,
				incident: WorkOrderIncidentLinker,
				request: WorkOrderRequestLinker,
				files: WorkOrderFileLinker,
				labels: WorkOrderLabelLinker,
			},
			[TableType.INCIDENTS]: {
				labels: IncidentLabelLinker,
				statusmessage: IncidentStatusLinker,
				priority: IncidentPriorityLinker,
				category: IncidentCategoryLinker,
				work_order: IncidentWorkOrderLinker,
				request: IncidentRequestLinker,
			},
			[TableType.REQUESTS]: {
				labels: RequestLabelLinker,
				statusmessage: RequestStatusLinker,
				priority: RequestPriorityLinker,
				category: RequestCategoryLinker,
				work_order: RequestWorkOrderLinker,
				incident: RequestIncidentLinker,
			},
		};
	}
	createLinker(tableType: TableType, targetType: ActionTypes): IActionCenterLinker<any> {
		const deps = this.deps[tableType];
		return new this.linkerMap[tableType][targetType](deps);
	}

	canCreate(tableType: TableType, targetType: ActionTypes): boolean {
		return this.linkerMap[tableType][targetType] !== undefined;
	}
}
